<script lang="ts">
  import { navigate } from 'svelte-navigator';

  import { _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import PartsDropdown from './parts-dropdown.svelte';
  import DealerDropdown from './dealer-dropdown.svelte';
  import { handleFetchRetry } from '../handleFetchRetry';
  import { identifyDealership } from '../registration/identifyDealership';
  import { debugLog } from '../../lib/debug-log';

  let URL = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbdwic`;

  let recognizedText: any = {};
  let dealerValue = '';
  let storageKind = '';
  let receipt: any = null;
  let dealershipInfo: any;
  let selectedParts: any;
  let invoiceDate: any;
  let switchValue: any;
  let partsCount: any;
  let pdfParserResponse: any = {};

  if (localStorage.getItem('recognizedText') !== null) {
    recognizedText = JSON.parse(
      localStorage.getItem('recognizedText') as string,
    );
  }

  // New flow stores server payload directly in recognizedText; keep pdfParserResponse empty

  if (localStorage.getItem('receipt') !== null) {
    receipt = JSON.parse(localStorage.getItem('receipt') as string);
    debugLog({ receipt });
    partsCount = receipt.partsCount;
  }

  const serverPayload: any = recognizedText; // now saved as body
  const response: any = serverPayload?.extractedData || {};
  const pdfData: any = serverPayload?.extractedData || {};

  const convertToDate = (dateString?: string): string => {
    try {
      let dt: Date;
      if (dateString) {
        const d = dateString.split('.');
        if (d.length === 3) {
          dt = new Date(Date.UTC(Number(d[2]), Number(d[1]) - 1, Number(d[0])));
        } else {
          dt = new Date();
        }
      } else {
        dt = new Date();
      }
      return dt.toISOString().split('T')[0];
    } catch (error) {
      return new Date().toISOString().split('T')[0];
    }
  };

  const onPartsCountKeyup = (e: KeyboardEvent) => {
    const target = e.currentTarget as HTMLInputElement;
    const value = Number(target.value);
    if (value < 0) partsCount = 0;
    if (value > 100) partsCount = 100;
  };

  const beforeNavigate = async () => {
    let partsId = JSON.parse(receipt.partsId);
    let isOverrided = !(partsCount.toString() == receipt.partsCount);

    if (partsId?.length !== selectedParts?.length) isOverrided = true;

    for (let k = 0; k < selectedParts?.length; k++) {
      if (!partsId?.find((p: any) => p == selectedParts?.[k].id)) {
        isOverrided = true;
      }
    }

    const dealershipRaw = await identifyDealership(
      `${pdfData?.DealershipName || response?.DealershipName || ''}, ${
        pdfData?.DealershipAddress?.zipCode ||
        response?.DealershipAddress?.zipCode ||
        ''
      }`,
      pdfData?.DealershipAddress?.zipCode ||
      response?.DealershipAddress?.zipCode ||
      ''
    );

    try {
      await handleFetchRetry(() =>
        fetch(`${URL}/purchasereceipts/${receipt.id}`, {
          method: 'PATCH',
          headers: {
            Accept: 'application/json, text/plain',
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Custom-Header': 'mb-cashback-2025-header',
          },
          body: JSON.stringify({
            partsCount: `${partsCount}`,
            partsId: JSON.stringify(selectedParts.map((s: any) => s.id)),
            partsIdentified: JSON.stringify(
              selectedParts.map((s: any) => s.key),
            ),
            partsOverrride: +isOverrided,
            purchaseDate: new Date(invoiceDate),
            purchaseDateOverride: +(invoiceDate !== receipt.invoiceDate),
            dealershipsId: dealershipInfo.value,
            dealerOverride: +(dealershipRaw.id !== dealershipInfo.value),
            switch: switchValue,
            switchOverride:
              '' + +(switchValue !== (response?.Description1 || '')),
            storage: storageKind,
            storageOverride:
              '' + +(storageKind !== (response?.Description2 || '')),
          }),
        }),
      );
    } catch (error) {
      debugLog({ error });
    }

    localStorage.setItem(
      'receipt',
      JSON.stringify({
        ...receipt,
        partsOverride: isOverrided,
        partsCount: partsCount.toString(),
        partsId: JSON.stringify(selectedParts.map((s: any) => s.id)),
        partsIdentified: JSON.stringify(selectedParts.map((s: any) => s.key)),
        storage: storageKind,
        storageOverride: '' + +(storageKind !== (response?.Description2 || '')),
      }),
    );
  };

  onMount(async () => {
    debugLog({ response, pdfData });

    // Invoice date from new response
    let datesIdentified = (
      pdfData?.InvoiceDate ||
      response?.InvoiceDate ||
      ''
    ).replaceAll(' ', '');
    let yearIdentified = datesIdentified?.split('.')[2];

    if (yearIdentified && yearIdentified.length == 2) {
      let day = datesIdentified.split('.')[0];
      let month = datesIdentified.split('.')[1];
      datesIdentified = `${day}.${month}.20${yearIdentified}`;
    }

    if (response || pdfData) {
      debugLog({ response, pdfData });

      dealerValue = pdfData?.DealershipName || response?.DealershipName || '';

      storageKind =
        (pdfData?.Description1?.includes('EINLAGERUNG')
          ? pdfData.Description1
          : '') ||
        response?.Description2 ||
        '';

      switchValue =
        (pdfData?.Description1?.includes('MONTAGE') ||
        pdfData?.Description1?.includes('MONTIEREN')
          ? pdfData.Description1
          : '') ||
        response?.Description1 ||
        '';

      invoiceDate = convertToDate(datesIdentified);
      receipt.invoiceDate = invoiceDate;
    } else {
      invoiceDate = convertToDate();
      receipt.invoiceDate = invoiceDate;
    }

    debugLog({ invoiceDate });
  });
</script>

<div class="flex w-full max-w-full flex-col gap-6 overflow-hidden">
  <!-- <div class="overflow-scroll background-red-500">
    <pre>
  {JSON.stringify(recognizedText.successful[0].response.body, null, 2)}
  </pre>
  </div> -->
  <h1 class="title mb-8">
    {$_('Purchase Information')}
  </h1>
  <!-- <div id="purchaseInformation" /> -->
  <div class="w-full">
    <p class="mb-4 font-sans text-sm text-[#333]">
      {$_('purchase-info-intro')}
    </p>

    <form class="grid w-full max-w-full gap-4">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="w-full">
        <div
          class="font-sans-Bold mb-1 text-xs font-semibold uppercase text-[#333]"
        >
          {$_('DEALER')}
        </div>
        <!-- <DealerDropdown /> -->
        <DealerDropdown bind:dealershipInfo dealer={dealerValue} zipCode={pdfData?.DealershipAddress?.zipCode || response?.DealershipAddress?.zipCode || ''} dealershipLocation={pdfData?.DealershipLocation || response?.DealershipLocation || ''} />
      </label>
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="w-full">
        <div
          class="font-sans-Bold mb-1 text-xs font-semibold uppercase text-[#333]"
        >
          {$_('PARTS')}
        </div>
        <PartsDropdown bind:selectedParts selectedIds={receipt?.partsId} />
      </label>
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="w-full">
        <div
          class="font-sans-Bold mb-1 text-xs font-semibold uppercase text-[#333]"
        >
          {$_('PARTS COUNT')}
        </div>

        <div class="w-full">
          <input
            class="input w-full"
            type="number"
            on:keyup={onPartsCountKeyup}
            bind:value={partsCount}
          />
        </div>
      </label>
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="w-full">
        <div
          class="font-sans-Bold mb-1 text-xs font-semibold uppercase text-[#333]"
        >
          {$_('EINLAGERUNG')}
        </div>

        <div class="w-full">
          <input class="input w-full" type="text" bind:value={storageKind} />
        </div>
      </label>
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="w-full">
        <div
          class="font-sans-Bold mb-1 text-xs font-semibold uppercase text-[#333]"
        >
          {$_('WECHSEL')}
        </div>

        <div class="w-full">
          <input class="input w-full" type="text" bind:value={switchValue} />
        </div>
      </label>
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="w-full">
        <div
          class="font-sans-Bold mb-1 text-xs font-semibold uppercase text-[#333]"
        >
          {$_('PURCHASE DATE')}
        </div>
        <div class="w-full">
          <input type="date" bind:value={invoiceDate} class="input w-full" />
        </div>
      </label>

      <div class="flex w-full justify-end py-4 font-sans">
        <div class="flex w-full items-center justify-between">
          <p class="text-sm text-red-500">
            * {$_('required')}
          </p>
          <button
            class="button mt-4"
            data-umami-event="next button on purchase information clicked"
            data-umami-event-page="/step/2"
            on:click|preventDefault={async () => {
              // update the purchaseInformation
              await beforeNavigate();
              navigate('/step/3');
            }}
          >
            {$_('Next')}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>